import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type EditDateNightRequest = Pick<EventType, "title" | "description" | "location" | "date"> & {
  eventId: EventType["id"];
};

export type EditDateNightResponse = EventType;

export const editDateNight = async ({ eventId, ...body }: EditDateNightRequest): Promise<EditDateNightResponse> => {
  const { data } = await axios.patch(`/events/date-nights/${eventId}/edit`, body);

  return data;
};
